export default __webpack_public_path__ + "static/media/3rd.c386c782.jpg";